<template>
<div class="mileage">
	<div class="titleMileage">
		<span class="text">Mileage:</span>
		<span class="value">
			<span class="meaning">{{ load.mileage_total }}</span>
			<svg-sprite style="color: #19BC38" width="20" height="20" icon-id="icon_mi"></svg-sprite>
		</span>
	</div>
	<div class="rowMileage">
		<field
				margin="0"
				label="Loaded"
				placeholder="Enter loaded"
				type="number"
				@updateInput="onInput($event, 'pick_up_mileage')"
				:setInputValue="load.pick_up_mileage"
				icon="mi"
				is-required
				iconGap="10px"
				:classError="hasErr('pick_up_mileage')"
		>
			<template slot="additionalElements">
				<template v-if="!invalidPickup && !invalidDelivery">
					<field-custom-icon-buttons
							v-for="(button, index) in customIconButtons"
							:key="button.icon"
							:index="index"
							:button="button"
							@updateCustomIconButton="onCustomIconButton($event, 'loaded')"
					></field-custom-icon-buttons>
				</template>
			</template>
		</field>
		<field
				margin="0"
				label="Empty"
				placeholder="Enter empty"
				type="number"
				@updateInput="onInput($event, 'mileage_empty')"
				:setInputValue="load.mileage_empty"
				icon="mi"
				is-required
				iconGap="10px"
				:classError="hasErr('mileage_empty')"
		>
			<template slot="additionalElements">
				<template v-if="!invalidPickup && !invalidDelivery && oldRoute">
					<field-custom-icon-buttons
							v-for="(button, index) in customIconButtons"
							:key="button.icon"
							:index="index"
							:button="button"
							@updateCustomIconButton="onCustomIconButton($event, 'empty')"
					></field-custom-icon-buttons>
				</template>
			</template>
		</field>
		<previous-trip
				v-if="oldRoute"
				:old-route="oldRoute"
				@updateOpenOldTrip="onOpenOldTrip"
		></previous-trip>
	</div>
</div>
</template>

<script>
import PreviousTrip from "@/components/Dispatch/Trips/DialogTrip/Load/PreviousTrip/PreviousTrip";
import FieldCustomIconButtons from "@/shared/Field/FieldCustomIconButtons.vue";
export default {
	name: "Mileage",
	components: {
		PreviousTrip,
		FieldCustomIconButtons
	},

	props: {
		load: Object,
		oldRoute: Object,
		invalidPickup: Boolean,
		invalidDelivery: Boolean,
		errors: Object,
	},
	computed: {
		hasErr() {
			return key => !!(this.errors && this.errors[key]);
		}
	},
	data() {
		return {
			pick_up_mileage: null,
			mileage_empty: null,
			mileage_total: null,
			customIconButtons: [
				{
					icon: "calculator",
					// disabled: this.validate.loads.$each.$iter[0].pickup.$invalid
				}
			]
		};
	},
	// this.$v.loads.$each.$iter[0].pickup.$error && this.$v.loads.$each.$iter[0].delivery.$error

	methods: {
		onInput({ value }, key, parent) {
			this[key] = value;
			this.mileage_total = Number(this.pick_up_mileage) + Number(this.mileage_empty);

			this.$emit('updateInput', { value, key, parent });
		},
		onCustomIconButton(btn, key) {
			this.$emit('updateCustomIconButton', { key, btn });
		},
		onOpenOldTrip(id) {
			this.$emit('updateOpenOldTrip', id);
		},
	},
	mounted() {
		const { mileage_empty, pick_up_mileage, mileage_total } = this.load;
		this.pick_up_mileage = pick_up_mileage;
		this.mileage_empty = mileage_empty;
		this.mileage_total = mileage_total;
	}
};
</script>

<style scoped lang="scss">
@import "mileage";
</style>
